
import { defineComponent } from 'vue';
import SideAvatar from '@/components/SideAvatar.vue';

export default defineComponent({
  components: {
    SideAvatar,
  },
  props: {
    semester: { type: String, required: true },
    hideLeft: { type: Boolean, default: false },
    hideRight: { type: Boolean, default: false },
  },
  emits: ['click-menu-button', 'click-left', 'click-right'],
  setup(props, ctx) {
    return {
      handleClickLeft() {
        if (!props.hideLeft) {
          ctx.emit('click-left');
        }
      },
      handleClickRight() {
        if (!props.hideRight) {
          ctx.emit('click-right');
        }
      },
    };
  },
});
